import classNames from 'classnames';

import { StatementPeriodType } from '../../../../../../../lib/models/fundamental/types';

import { ClickableDiv } from '../../../../../../../components';
import { balanceChartData, cashFlowChartData, incomeChartData } from '../../../Financials.types';
import { emptyDataKey } from '../../Chart.constants';

import styles from './OptionsBar.module.scss';

type Props = {
  data: cashFlowChartData[] | incomeChartData[] | balanceChartData[];
  selectedOption: number;
  setSelectedOption: (index: number) => void;
  period: StatementPeriodType;
};

const OptionsBar = (props: Props) => {
  const { data, selectedOption, setSelectedOption, period } = props;

  const renderQuarterPeriod = (quarterPeriod: string, year: number) => (quarterPeriod.includes('Q') ? `${quarterPeriod}'${year.toString().slice(2)}` : '');

  return (
    <div className={styles.options}>
      { data.map((item, index) => (
        <div key={`${item.key}-${item.period}`}>
          {item.key === emptyDataKey ? (
            <div className={styles.emptyOption} />
          ) : (
            <ClickableDiv
              className={classNames(styles.option, { [styles.activeOption]: selectedOption === index })}
              onClick={() => setSelectedOption(index)}
            >
              {period === StatementPeriodType.ANNUAL ? item.key : renderQuarterPeriod(item.period, item.key)}
            </ClickableDiv>
          )}
        </div>
      ))}
    </div>
  );
};

export default OptionsBar;
